import { Icon } from "@iconify/react";
import { Trans } from "react-i18next";

import { ProjectData } from "../sidebar/project";

import Postit from "../../../components/Postit";
import OldImage from "../../../components/OldImage";
import TextLink from "../../../components/TextLink";
import LocalVideo from "../../../components/LocalVideo";
import Skills from "../../../components/Skills";

export const Donald = (): ProjectData => {
  return {
    title: "Donald",
    description: "A Website for Supporting Children with Autism",
    thumbnail: "/images/donald/hackathon_2024.png",
    date: "Jun 2024",

    information: [
      <OldImage
        key="website"
        src="/images/donald/website.png"
        alt="Website"
        className="col-span-full xl:col-span-2 xl:row-span-2"
      />,

      <Postit key="intro">
        <TextLink href="https://aohkne.github.io/Donald/">Donald</TextLink>{" "}
        <Trans i18nKey="intro" ns="donald" />
      </Postit>,

      <Skills
        key="skills"
        skills={[
          "JavaScript",
          "HTML & CSS",
          "Bootstrap",
          "Github Page",
          "Gemini API",
        ]}
      />,

      <Postit className="col-span-full xl:col-span-2" key="context">
        <Trans
          i18nKey="context"
          ns="donald"
          components={{
            link: (
              <TextLink href="https://www.facebook.com/photo.php?fbid=855490849951997&id=100064732690759&set=a.554410226726729">
                Đại học FPT
              </TextLink>
            ),
          }}
        />
      </Postit>,

      <OldImage
        key="team"
        src="/images/donald/hackathon_2024.png"
        alt="Team"
        className="col-span-full xl:col-span-1"
      />,

      <OldImage
        key="award"
        src="/images/donald/award.png"
        alt="Achievement"
        className="col-span-full xl:col-span-2 xl:row-span-2"
      />,

      <Postit key="reflection">
        <Trans i18nKey="reflection" ns="donald" />
      </Postit>,

      <OldImage
        key="logo"
        src="/images/donald/logo.png"
        alt="Logo"
        className="col-span-full xl:col-span-1"
      />,

      <LocalVideo
        key="demo"
        src="images/donald/demo.mov"
        alt="Website Demo"
        className="col-span-full mt-6"
      />,

      <div
        key="links"
        className="
          col-span-full
          mt-6
          flex flex-col sm:flex-row
          gap-4
          justify-center
          items-center
          text-sm sm:text-base
        "
      >
        <TextLink
          href="https://github.com/Aohkne/Donald"
          className="flex items-center gap-2 text-gray-600 font-medium"
        >
          <Icon icon="openmoji:github" width="24" height="24" />
          PROJECT
        </TextLink>

        <TextLink
          href="https://aohkne.github.io/Donald/"
          className="flex items-center gap-2 text-gray-600 font-medium"
        >
          <Icon icon="openmoji:code-editor" width="24" height="24" />
          WEBSITE
        </TextLink>
      </div>,
    ],
  };
};
